import script from "./EmptyLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyLayout.vue?vue&type=script&setup=true&lang=js"

import "./EmptyLayout.vue?vue&type=style&index=0&id=f429027e&lang=css"

const __exports__ = script;

export default __exports__